import { render, staticRenderFns } from "./verificationDetail.vue?vue&type=template&id=1c4a6638&scoped=true"
import script from "./verificationDetail.vue?vue&type=script&lang=js"
export * from "./verificationDetail.vue?vue&type=script&lang=js"
import style0 from "./verificationDetail.vue?vue&type=style&index=0&id=1c4a6638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a6638",
  null
  
)

export default component.exports